import { render, staticRenderFns } from "./Gallerysection.vue?vue&type=template&id=1da9bd4c&scoped=true"
import script from "./Gallerysection.vue?vue&type=script&lang=js"
export * from "./Gallerysection.vue?vue&type=script&lang=js"
import style0 from "./Gallerysection.vue?vue&type=style&index=0&id=1da9bd4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da9bd4c",
  null
  
)

export default component.exports